import apiFetch from '../apiFetch'

export default function (token, dossierId) {
  return apiFetch({ endPoint: `dossier/sale/${dossierId}/documentaryChecklist`, method: 'GET', token: token })
}
